import 'react-app-polyfill/ie11';
import 'react-app-polyfill/stable';
import React from 'react';
import ReactDOM from 'react-dom';
import { BrowserRouter } from 'react-router-dom';
import App from './App';
import registerServiceWorker from './registerServiceWorker';
import $ from 'jquery';
import './components/css/dark/bootstrap.css';

// Load appropriate CSS based on host
// Note: No-cache headers are configured in Startup.cs for main.css and rxhacker.css
// This ensures fresh CSS is loaded on every deployment without manual cache clearing
if (window.location.host.split('.').slice(-2).join('.').toLowerCase() == "rxhacker.com" || 
    window.location.host.split('.').slice(-2).join('.').toLowerCase() == "localhost:5464" || 
    window.location.host.toLowerCase() == "tempfilter-dev.glichealth.com" || 
    window.location.host.toLowerCase() == "reporting.nulifespanrx.com") {
    import("./components/css/dark/rxhacker.css");
    $('body').addClass('rx-user');
} else {
    import("./components/css/dark/main.css");
}

// setup fake backend
//import { configureFakeBackend } from './_helpers';
const baseUrl = document.getElementsByTagName('base')[0].getAttribute('href');
const rootElement = document.getElementById('root');
//configureFakeBackend();

setTimeout(() => {
    ReactDOM.render(
        //<BrowserRouter basename={baseUrl}>
        //      <App />
        //</BrowserRouter>,
        <App />,
        rootElement);
    //registerServiceWorker();
}, 400);
